import axios from 'axios'
import getConfig from '../config'
const { API_BASE_URI } = getConfig()
const CancelToken = axios.CancelToken
let cancel

export async function createFile (files, onUploadProgress) {
  const data = new FormData()
  data.append('name', files[0].name.split(' ').join('%20'))
  data.append('file', files[0])

  const config = {
    onUploadProgress: onUploadProgress
  }
  const response = await axios.post(`${API_BASE_URI}/files`, data, config)
  return response.data
}

export async function listFiles ({ search, limit, offset, sort, filters = {} }) {
  // Check if there are any previous pending requests
  if (typeof cancel !== typeof undefined) {
    cancel()
    // console.log('cancelled')
  }

  try {
    const { type } = filters
    let url = `${API_BASE_URI}/files?limit=${limit}&offset=${offset}&_=${Date.now()}`
    url += type ? `&type=${type}` : ''
    url += sort ? `&sort=${sort}` : ''
    url += search ? `&searchBy=${search}` : ''

    const response = await axios({
      method: 'get',
      url,
      cancelToken: new CancelToken(function executor (c) {
        cancel = c
      })
    })

    return response.data
  } catch (e) {
    if (axios.isCancel(e)) {
       // do not pass cancelled request as error
    } else {
      throw e
    }
  }
}

export async function getFile ({ id }) {
  const url = `${API_BASE_URI}/files/${id}?_=${Date.now()}`
  const response = await axios({
    method: 'get',
    url
  })
  return response.data
}

export async function getFileByFilename ({ filename }) {
  const url = `${API_BASE_URI}/files/filename?filename=${filename}&_=${Date.now()}`
  const response = await axios({
    method: 'get',
    url
  })
  return response.data
}

export async function deleteFile (id) {
  let url = `${API_BASE_URI}/files/${id}?_=${Date.now()}`
  const response = await axios({
    method: 'delete',
    url
  })
  return response.data
}

export async function deleteFiles (data) {
  let url = `${API_BASE_URI}/files?ids=${data.toString()}&_=${Date.now()}`
  const response = await axios({
    method: 'delete',
    url
  })
  return response.data
}

export async function replaceFile ({ id, location, tempFileId }) {
  let url = `${API_BASE_URI}/files/${id}/replace`
  if (location) {
    url += `?location=${location}`
  } else if (tempFileId) {
    url += `?tempFileId=${tempFileId}`
  }
  const response = await axios({
    method: 'post',
    url,
    data: {}
  })
  return response.data
}



// WEBPACK FOOTER //
// ./src/api/files.js